import React, { useState, useRef, useMemo } from "react";
import "./InformationsPerso.scss";
import { useForm, Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { InputTextarea } from "primereact/inputtextarea";
import data from "assets/countries";
import BtnEcouteMarche from "Components/Boutons/BtnEcouteMarche/BtnEcouteMarche";
import ReactDatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { fr } from "date-fns/locale";
import { Checkbox } from "primereact/checkbox";
import NavBarTab from "Components/NavBar/NavBarTab/NavBarTab";
import ProfilBarShowApercu from "Components/ProfilBar/ProfilBarShow/ProfilBarShowAperçu/ProfilBarShowApercu";
import BtnBleuLeft from "Components/Boutons/BtnBleuLeft/btn-bleu-left";
import { updateAuth, updateCompletionLevel } from "Redux/Actions/authActions";
import { FaCheck } from "react-icons/fa";
import { Toast } from "primereact/toast";
import axios from "axios";
import ChargementImage from "Components/ChargementImage/ChargementImage";
import {
  changeOrderDateWithDay,
  convert,
  formatDate,
} from "Services/functions";
import BtnRetour from "Components/Boutons/BtnRetour/btn-retour";
import { CgClose } from "react-icons/cg";
import { isPossiblePhoneNumber } from "react-phone-number-input";
import PhoneInput from "react-phone-number-input/input";

registerLocale("fr", fr);

const InformationsPerso = (props) => {
  const [formData, setFormData] = useState(props.auth.userConnected);
  const [modified, setModified] = useState(true);
  const [filtreDate, setFiltreDate] = useState(
    props.auth.userConnected.birthday
  );

  const successUpdate = useRef(null);
  const pictureSuccessUpdate = useRef(null);
  // ------- TOASTS ----------
  // Toast de succès d'upload d'image
  const uploadToast = useRef(null);
  // Toast de suppression de l'image upload
  const cancelToast = useRef(null);

  // ------- VARIABLES GESTION IMAGES ----------
  // La photo vient-elle de la photothèque ?
  const [phototheque, setPhototheque] = useState(
    props.auth.userConnected.imageUrl ? false : true
  );
  // Contiendra l'url de l'image choisie (upload ou photothèque)
  const [imageFile, setImageFile] = useState("");
  // Contiendra le fichier upload par l'utilisateur
  const [image, setImage] = useState(
    props.auth.userConnected.imageUrl ? props.auth.userConnected.imageUrl : ""
  );
  // Id de l'image choisie (phototheque)
  const [imageId, setImageId] = useState("");
  const {
    control,
    register,
    formState: { errors },
    handleSubmit,
    setValue,
    getValues,
    reset,
  } = useForm({
    defaultValues: useMemo(() => {
      return {
        ...props.auth.userConnected,
        birthday: formatDate(props.auth.userConnected.birthday),
      };
    }, [props.auth.userConnected]),
  });
  const onSubmit = (data) => {
    setFormData(data);
    setModified(false);
    // onUpdate();
    // reset();
  };

  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  /**
   * Remplissage de la key image selon différentes conditions
   * @param {Object} data données pour la requêtes
   * @returns {Object}
   */
  const fillImage = (data) => {
    // Si une image a été téléchargée, on met son url local dans la key imageFile
    if (imageFile && !phototheque) {
      data.imageFile = imageFile;
      delete data.imageStockId;
    }
    // Sinon, on met l'url de l'image choisie de la photothèque
    else if (phototheque) {
      data.imageStockId = imageId;
      delete data.imageFile;
      delete data.image;
    }
    return data;
  };

  const putImageStock = async (id) => {
    let url = `${process.env.REACT_APP_BASE_URL_API}/users/${props.auth.userConnected.id}/updateImageStock`;
    let data = {
      id: id,
    };
    axios
      .post(url, data, {
        headers: {
          Authorization: `Bearer ${props.auth.token}`,
        },
      })
      .then((res) => {
        if (res.status === 201) {
          setFormData({
            ...res.data,
            birthday: formatDate(res.data.birthday),
          });
          props.handleUpdateAuth({
            userConnected: res.data,
          });
        }
      })
      .catch((err) => {
        showPictureSuccess({
          severity: "error",
          summary: "Erreur",
          detail: err?.response?.data?.detail || "Une erreur est survenue",
        });
      });
  };

  const putPicture = async (imageSrc) => {
    let url = `${process.env.REACT_APP_BASE_URL_API}/users/${props.auth.userConnected.id}/updatePicture`;
    let formData = new FormData();
    formData.append("imageFile", imageSrc);
    axios
      .post(url, formData, {
        headers: props.auth.token
          ? {
              accept: "application/json",
              "Content-Type": "multipart/form-data",

              Authorization: `Bearer ${props.auth.token}`,
            }
          : {
              accept: "application/json",
              "Content-Type": "multipart/form-data",
            },
      })
      .then((res) => {
        if (res.status === 201) {
          setFormData({
            ...res.data,
            birthday: formatDate(res.data.birthday),
          });
          props.handleUpdateAuth({
            userConnected: res.data,
          });
        }
      })
      .catch((err) => {
        showPictureSuccess({
          severity: "error",
          summary: "Erreur",
          detail: err.response.data.detail,
        });
      });
  };

  /**
   * It changes the order of the date, fills the image, and deletes the unnecessary fields
   * @param values - The values of the form.
   * @returns the values after the verification.
   */
  function verifyFields(values) {
    if (values.birthday)
      values.birthday = changeOrderDateWithDay(values.birthday);
    values = fillImage(values);
    ["id", "imageUrl", "imageFile", "imageStockId"].forEach((key) => {
      delete values[key];
    });
    return values;
  }

  /**
   * It updates the user's profile
   */
  const onUpdate = () => {
    //? Remove id de l'objet props.user et modification l'objet du CV
    // let userObj = { ...formData };
    let userObj = verifyFields(getValues());
    if (userObj.birthday === "") userObj.birthday = null;

    const cVId = userObj.resume.id;
    isNaN(cVId)
      ? (userObj.resume = cVId)
      : (userObj.resume = `/api/cvs/${cVId}`);
    axios
      .put(
        `${process.env.REACT_APP_BASE_URL_API}/users/${props.auth.userConnected.id}`,
        userObj,
        {
          headers: props.auth.token
            ? {
                accept: "application/json",
                "Content-Type": "application/json",

                Authorization: `Bearer ${props.auth.token}`,
              }
            : {
                accept: "application/json",
                "Content-Type": "application/json",
              },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          reset();
          setFormData({
            ...res.data,
            birthday: formatDate(res.data.birthday),
          });
          axios
            .get(
              `${process.env.REACT_APP_BASE_URL_API}/users/${props.auth.userConnected.id}/profile_completion_rate`,
              {
                headers: props.auth.token
                  ? {
                      accept: "application/json",
                      "Content-Type": "application/json",

                      Authorization: `Bearer ${props.auth.token}`,
                    }
                  : {
                      accept: "application/json",
                      "Content-Type": "application/json",
                    },
              }
            )
            .then((res) => props.handleUpdateCompletionLevel(res.data))
            .catch((error) =>
              props.auth.toast?.current?.show({
                severity: "error",
                summary: "Erreur",
                detail:
                  error?.response?.data?.detail || "Une erreur est survenue",
                life: 5000,
              })
            );
          props.handleUpdateAuth({ userConnected: { ...res.data } });
          setFormData({
            ...res.data,
            birthday: formatDate(res.data.birthday),
          });
          if (imageFile && imageFile !== props.auth.userConnected.imageUrl)
            putPicture(imageFile);
          else if (
            (imageId &&
              phototheque &&
              props.auth.userConnected.imageUrl &&
              imageId !==
                props.auth.userConnected.imageUrl.slice(
                  props.auth.userConnected.imageUrl.lastIndexOf("/") + 1
                )) ||
            !props.auth.userConnected.imageUrl
          )
            putImageStock(imageId);
          setModified(false);
          showSuccess();
        }
      })
      .catch((error) =>
        props.auth.toast?.current?.show({
          severity: "error",
          summary: "Erreur",
          detail: error?.response?.data?.detail || "Une erreur est survenue",
          life: 5000,
        })
      );
  };

  const showSuccess = () => {
    successUpdate.current.show({
      severity: "success",
      summary: "Mise à jour effectuée avec succès",
      detail: "Votre mise à jour a bien été prise en compte",
      life: 5000,
    });
  };

  const showPictureSuccess = (data) => {
    successUpdate.current.show({
      severity: data.severity,
      summary: data.summary,
      detail: data.detail,
      life: 5000,
    });
  };

  const [isVisibleAdress, setIsVisibleAdress] = useState(false);
  const [listOfAdress, setListOfAdress] = useState([]);
  const [currentCountry, setCurrentCountry] = useState(getValues("country"));

  const getAdress = (adress) => {
    let listOfAdresses = [];
    axios
      .get(
        `https://api-adresse.data.gouv.fr/search/?q=${adress}&type=housenumber&autocomplete=1`
      )
      .then((res) => {
        res.data.features.forEach((adress) =>
          listOfAdresses.push([
            adress.properties.label,
            adress.properties.context,
            adress.properties.city,
          ])
        );
        setListOfAdress(listOfAdresses);
      });
  };

  return (
    <div className="edit_profil">
      <Toast ref={cancelToast} />
      <Toast ref={uploadToast} />
      <Toast ref={successUpdate} />
      <Toast ref={pictureSuccessUpdate} />
      {props.auth.isConnected && (
        <div className="article_actu">
          <NavBarTab
            id="desktop"
            select="profiledit"
            activeIndex={props.activeIndex}
            items={props.items}
          />
          <BtnEcouteMarche items={props.items} />

          <div className="edit_profil__title">
            <div>
              <h1 className="h1_trait_dessus">
                Modifier mes {props.items[props.activeIndex].label}
              </h1>
              <p>
                Le remplissage de votre profil permet d&apos;alimenter
                l&apos;annuaire et votre CV Réseau Pro
              </p>
            </div>
            <BtnRetour />
          </div>
          <div className="form-demo profil-form-demo">
            {modified ? (
              <form
                className="p-fluid edit_profil__informationPersoForm"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="field">
                  <div className="field__photoProfil">
                    <ChargementImage
                      label="Photo de profil"
                      image={image}
                      setImage={setImage}
                      imageFile={imageFile}
                      setImageFile={setImageFile}
                      setImageId={setImageId}
                      uploadToast={uploadToast}
                      cancelToast={cancelToast}
                      phototheque={phototheque}
                      setPhototheque={setPhototheque}
                      path="users"
                      currentImage={props.auth.userConnected.imageUrl}
                    />
                  </div>
                </div>
                <div className="field">
                  <h2>Titre du profil *</h2>
                  <Controller
                    name="profilTitle"
                    control={control}
                    rules={{ required: "Le titre du profil est requis" }}
                    render={({ field, fieldState }) => (
                      <InputText
                        id={field.name}
                        placeholder="Étudiant Master Droit, Chargé de projet marketing..."
                        {...field}
                        className={classNames({
                          "p-invalid": fieldState.invalid,
                        })}
                      />
                    )}
                  />

                  {getFormErrorMessage("profilTitle")}
                </div>
                <div className="form_columns">
                  <div className="field">
                    <h2>Nom *</h2>
                    <Controller
                      name="surname"
                      control={control}
                      rules={{ required: "Le nom est requis" }}
                      render={({ field, fieldState }) => (
                        <InputText
                          id={field.name}
                          disabled={true}
                          placeholder="Dupont..."
                          {...field}
                          className={classNames({
                            "p-invalid": fieldState.invalid,
                          })}
                        />
                      )}
                    />

                    {getFormErrorMessage("surname")}
                  </div>
                  <div className="field">
                    <h2>Prénom *</h2>
                    <Controller
                      name="firstname"
                      control={control}
                      rules={{ required: "Le prénom est requis" }}
                      render={({ field, fieldState }) => (
                        <InputText
                          id={field.name}
                          disabled={true}
                          placeholder="Marie, Arthur..."
                          {...field}
                          //   autoFocus
                          className={classNames({
                            "p-invalid": fieldState.invalid,
                          })}
                        />
                      )}
                    />
                    {getFormErrorMessage("firstname")}
                  </div>
                </div>
                <div className="form_columns">
                  <div className="field">
                    <h2>Nom d&apos;usage</h2>
                    <Controller
                      name="useSurname"
                      control={control}
                      render={({ field, fieldState }) => (
                        <InputText
                          id={field.name}
                          placeholder="Si différent du nom"
                          {...field}
                          //   autoFocus
                          className={classNames({
                            "p-invalid": fieldState.invalid,
                          })}
                        />
                      )}
                    />
                    {getFormErrorMessage("useSurname")}
                  </div>
                  <div className="field">
                    <h2>Prénom d&apos;usage</h2>
                    <Controller
                      name="useFirstname"
                      control={control}
                      render={({ field, fieldState }) => (
                        <InputText
                          id={field.name}
                          placeholder="Si différent du prénom"
                          {...field}
                          //   autoFocus
                          className={classNames({
                            "p-invalid": fieldState.invalid,
                          })}
                        />
                      )}
                    />

                    {getFormErrorMessage("useFirstname")}
                  </div>
                </div>
                <div className="field">
                  <h2>Description</h2>
                  <Controller
                    name="profilDescription"
                    control={control}
                    render={({ field, fieldState }) => (
                      <InputTextarea
                        id={field.name}
                        placeholder="Passionné de mécanique, je suis à la recherche de..."
                        {...field}
                        //   autoFocus
                        className={classNames({
                          "p-invalid": fieldState.invalid,
                        })}
                        rows={5}
                      />
                    )}
                  />
                  {getFormErrorMessage("profilDescription")}
                </div>

                <div className="form_columns">
                  <div className="field">
                    <h2>Compte LinkedIn</h2>
                    <Controller
                      name="linkedinAccount"
                      control={control}
                      render={({ field, fieldState }) => (
                        <InputText
                          id={field.name}
                          placeholder="www.linkedin.com/in/..."
                          {...field}
                          className={classNames({
                            "p-invalid": fieldState.invalid,
                          })}
                        />
                      )}
                    />
                    {getFormErrorMessage("linkedinAccount")}
                  </div>
                  <div className="field">
                    <h2>Compte Facebook</h2>
                    <Controller
                      name="facebookAccount"
                      control={control}
                      render={({ field, fieldState }) => (
                        <InputText
                          id={field.name}
                          placeholder="www.facebook.com/..."
                          {...field}
                          className={classNames({
                            "p-invalid": fieldState.invalid,
                          })}
                        />
                      )}
                    />
                    {getFormErrorMessage("facebookAccount")}
                  </div>
                </div>
                <div className="form_columns">
                  <div className="field">
                    <h2>Compte Instagram</h2>
                    <Controller
                      name="instagramAccount"
                      control={control}
                      render={({ field, fieldState }) => (
                        <InputText
                          ref={register}
                          id={field.name}
                          placeholder="www.instagram.com/..."
                          {...field}
                          className={classNames({
                            "p-invalid": fieldState.invalid,
                          })}
                        />
                      )}
                    />
                    {getFormErrorMessage("instagramAccount")}
                  </div>
                  <div className="field">
                    <h2>Compte Twitter</h2>
                    <Controller
                      name="twitterAccount"
                      control={control}
                      render={({ field, fieldState }) => (
                        <InputText
                          id={field.name}
                          placeholder="www.twitter.com/..."
                          {...field}
                          className={classNames({
                            "p-invalid": fieldState.invalid,
                          })}
                        />
                      )}
                    />
                    {getFormErrorMessage("twitterAccount")}
                  </div>
                </div>

                <div className="field">
                  <h2>Date de naissance</h2>
                  <div className="field__calendrier">
                    <Controller
                      name="birthday"
                      control={control}
                      render={({ field, fieldState }) => (
                        <ReactDatePicker
                          {...field}
                          id={field.name}
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                          maxDate={new Date()}
                          placeholderText="20/09/2022"
                          // selected={
                          //   field.value == "" ? "" : convert(field.value)
                          // }
                          value={field.value}
                          dateFormat="dd/MM/yyyy"
                          onChange={(e) => {
                            field.onChange(convert(e));
                            setFiltreDate(true);
                          }}
                          className={
                            (classNames({
                              "p-invalid": fieldState.invalid,
                            }),
                            "small_item p-inputtext p-component datePickerInfoPerso")
                          }
                        />
                      )}
                    />
                    {filtreDate && (
                      <CgClose
                        onClick={() => {
                          setValue("birthday", null);
                          setFiltreDate(false);
                        }}
                      ></CgClose>
                    )}
                    {getFormErrorMessage("birthday")}
                  </div>
                </div>
                <div className="form_columns">
                  <div className="field">
                    <h2>Adresse mail</h2>
                    <Controller
                      name="email"
                      control={control}
                      rules={{
                        required: "L'adresse mail est requise",
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                          message:
                            "Adresse mail invalide. Ex. example@email.com",
                        },
                      }}
                      render={({ field, fieldState }) => (
                        <InputText
                          disabled={true}
                          id={field.name}
                          placeholder="hello123@gmail.com"
                          {...field}
                          className={classNames({
                            "p-invalid": fieldState.invalid,
                          })}
                        />
                      )}
                    />
                    {getFormErrorMessage("email")}
                    <div className="field checkbox">
                      <Controller
                        name="mailIsPublic"
                        control={control}
                        render={({ field }) => (
                          <Checkbox
                            id={field.name}
                            checked={!field.value}
                            onChange={(e) => field.onChange(!e.checked)}
                          />
                        )}
                      />
                      <label htmlFor="mailIsPublic">
                        Rendre privée mon adresse mail
                      </label>
                      {getFormErrorMessage("mailIsPublic")}
                    </div>
                  </div>

                  <div className="field">
                    <h2 className={errors.telephone ? "p-error" : ""}>
                      Numéro de téléphone *
                    </h2>
                    <Controller
                      name="telephone"
                      control={control}
                      rules={{
                        validate: (value) =>
                          value
                            ? isPossiblePhoneNumber(value) ||
                              "Numéro de téléphone invalide"
                            : "Un numéro de téléphone est requis",
                      }}
                      render={({ field }) => (
                        <PhoneInput
                          id={field.name}
                          {...field}
                          onChange={(e) => field.onChange(e || "")}
                          placeholder="+33 6 00 00 00 00"
                          className="p-inputtext p-component"
                        />
                      )}
                    />

                    {getFormErrorMessage("telephone")}
                    <div className="field checkbox">
                      <Controller
                        name="telephoneIsPublic"
                        control={control}
                        render={({ field }) => (
                          <Checkbox
                            id={field.name}
                            checked={!field.value}
                            onChange={(e) => field.onChange(!e.checked)}
                          />
                        )}
                      />
                      <label htmlFor="telephoneIsPublic">
                        Rendre privé mon numéro de téléphone
                      </label>
                      {getFormErrorMessage("telephoneIsPublic")}
                    </div>
                  </div>
                </div>

                <div className="field petit">
                  <h2>Pays</h2>
                  <Controller
                    name="country"
                    control={control}
                    render={({ field }) => (
                      <Dropdown
                        id={field.name}
                        placeholder="France, Belgique..."
                        value={field.value}
                        onChange={(e) => {
                          field.onChange(e.value);
                          setCurrentCountry(e.value);
                          setIsVisibleAdress(false);
                        }}
                        options={data}
                      />
                    )}
                  />
                  {getFormErrorMessage("country")}
                </div>

                <div className="form_columns">
                  <div className="field ville">
                    <h2>Adresse postale</h2>
                    <Controller
                      name="address"
                      control={control}
                      render={({ field, fieldState }) => (
                        <InputText
                          id={field.name}
                          placeholder="12 boulevard des coquelicots..."
                          {...field}
                          className={classNames({
                            "p-invalid": fieldState.invalid,
                          })}
                          onChange={(e) => {
                            field.onChange(e.target.value);
                            if (currentCountry === "France") {
                              if (e.target.value.length > 2) {
                                setIsVisibleAdress(true);
                                getAdress(e.target.value);
                              } else {
                                setIsVisibleAdress(false);
                              }
                            }
                          }}
                        />
                      )}
                    />
                    {isVisibleAdress && (
                      <div className="listOfAdresses">
                        {listOfAdress.map((adress, key) => (
                          <div
                            className="searchedAdress"
                            key={key}
                            onClick={() => {
                              setValue("address", adress[0]);
                              setValue("city", adress[2]);
                              setIsVisibleAdress(false);
                            }}
                          >
                            <div className="adress">{adress[0]}</div>
                            <div className="department">{adress[1]}</div>
                          </div>
                        ))}
                      </div>
                    )}

                    {getFormErrorMessage("address")}
                    <div className="field checkbox">
                      <Controller
                        name="addressIsPublic"
                        control={control}
                        render={({ field }) => (
                          <Checkbox
                            id={field.name}
                            checked={!field.value}
                            onChange={(e) => field.onChange(!e.checked)}
                          />
                        )}
                      />

                      <label htmlFor="addressIsPublic">
                        Rendre privée mon adresse postale
                      </label>

                      {getFormErrorMessage("addressIsPublic")}
                    </div>
                  </div>
                  <div className="field ville">
                    <h2>Ville</h2>
                    <Controller
                      name="city"
                      control={control}
                      render={({ field, fieldState }) => (
                        <InputText
                          id={field.name}
                          placeholder="Paris, Metz..."
                          {...field}
                          //   autoFocus
                          className={classNames({
                            "p-invalid": fieldState.invalid,
                          })}
                        />
                      )}
                    />
                    {getFormErrorMessage("city")}

                    {/* <div className="form_columns"> */}
                    <div className="field checkbox">
                      <Controller
                        name="cityAndCountryIsPublic"
                        control={control}
                        render={({ field }) => (
                          <Checkbox
                            id={field.name}
                            checked={!field.value}
                            onChange={(e) => field.onChange(!e.checked)}
                          />
                        )}
                      />
                      <label htmlFor="cityAndCountryIsPublic">
                        Rendre privés ma ville et mon pays
                      </label>
                      {getFormErrorMessage("cityAndCountryIsPublic")}
                    </div>
                  </div>
                </div>

                {/* </div> */}
                <div className="field parrain">
                  <h3>Permis</h3>
                  <div className="permis_container">
                    <div className="permis">
                      <Controller
                        name="permisA"
                        control={control}
                        render={({ field }) => (
                          <Checkbox
                            id={field.name}
                            checked={field.value}
                            value={false}
                            onChange={(e) => field.onChange(e.checked)}
                          />
                        )}
                      />
                      <label htmlFor="permisA">Permis A - moto</label>
                    </div>
                    <div className="permis">
                      <Controller
                        name="permisAM"
                        control={control}
                        render={({ field }) => (
                          <Checkbox
                            id={field.name}
                            checked={field.value}
                            value={false}
                            onChange={(e) => field.onChange(e.checked)}
                          />
                        )}
                      />
                      <label htmlFor="permisAM">Permis AM - cyclomoteur</label>
                    </div>
                    <div className="permis">
                      <Controller
                        name="permisB"
                        control={control}
                        render={({ field }) => (
                          <Checkbox
                            id={field.name}
                            checked={field.value}
                            value={false}
                            onChange={(e) => field.onChange(e.checked)}
                          />
                        )}
                      />
                      <label htmlFor="permisB">Permis B - auto</label>
                    </div>
                  </div>
                  <div className="permis_container">
                    <div className="permis">
                      <Controller
                        name="permisCD"
                        control={control}
                        render={({ field }) => (
                          <Checkbox
                            id={field.name}
                            checked={field.value}
                            value={false}
                            onChange={(e) => field.onChange(e.checked)}
                          />
                        )}
                      />
                      <label htmlFor="permisCD">
                        Permis C et/ou D - professionnels
                      </label>
                    </div>
                    <div className="permis">
                      <Controller
                        name="permisE"
                        control={control}
                        render={({ field }) => (
                          <Checkbox
                            id={field.name}
                            value={false}
                            checked={field.value}
                            onChange={(e) => field.onChange(e.checked)}
                          />
                        )}
                      />
                      <label htmlFor="permisE">Permis E - remorque</label>
                    </div>
                  </div>
                </div>
                {props.auth.userConnected.userRoles.some(
                  (role) => role.roleName == "ROLE_ALUMNI"
                ) ? (
                  <div className="form_columns">
                    <div className="field parrain">
                      <h3>
                        Parrainer un étudiant <br />
                      </h3>

                      <Controller
                        name="mentorAccept"
                        control={control}
                        render={({ field }) => (
                          <Checkbox
                            id={field.name}
                            checked={field.value}
                            onChange={(e) => field.onChange(e.checked)}
                          />
                        )}
                      />
                      <label htmlFor="mentorAccept">Parrain/Marraine</label>
                      <label className="label_parrain">
                        (vous acceptez d&apos;être contacté par des étudiants à
                        la recherche de conseils)
                      </label>
                      {getFormErrorMessage("mentorAccept")}
                    </div>
                    <div className="field parrain">
                      <h3>Créateur d&apos;entreprise</h3>
                      <Controller
                        name="companyCreator"
                        control={control}
                        render={({ field }) => (
                          <Checkbox
                            id={field.name}
                            checked={field.value}
                            onChange={(e) => field.onChange(e.checked)}
                          />
                        )}
                      />
                      <label htmlFor="companyCreator">
                        Je suis créateur d&apos;entreprise
                      </label>
                      {getFormErrorMessage("companyCreator")}
                    </div>
                  </div>
                ) : (
                  <div className="field parrain">
                    <h3>Créateur d&apos;entreprise</h3>
                    <Controller
                      name="companyCreator"
                      control={control}
                      render={({ field }) => (
                        <Checkbox
                          id={field.name}
                          checked={field.value}
                          onChange={(e) => field.onChange(e.checked)}
                        />
                      )}
                    />
                    <label htmlFor="companyCreator">
                      Je suis créateur d&apos;entreprise
                    </label>
                    {getFormErrorMessage("companyCreator")}
                  </div>
                )}

                <br />

                <div className="form_boutons btnInfoPersoValider">
                  <BtnBleuLeft btnTexte="Valider">
                    <FaCheck />
                  </BtnBleuLeft>
                </div>
              </form>
            ) : (
              <>
                <ProfilBarShowApercu data={formData} image={image} />
                <div className="form_boutons">
                  <BtnBleuLeft btnTexte="Valider " btnAction={() => onUpdate()}>
                    <FaCheck />
                  </BtnBleuLeft>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

InformationsPerso.propTypes = {
  auth: PropTypes.object,
  items: PropTypes.array,
  activeIndex: PropTypes.number,
  handleUpdateAuth: PropTypes.func,
  handleUpdateCompletionLevel: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdateAuth: (value) => {
    dispatch(updateAuth(value));
  },
  handleUpdateCompletionLevel: (value) => {
    dispatch(updateCompletionLevel(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(InformationsPerso);
